import { Flex } from '@chakra-ui/react';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Badge, BadgeVariants } from '@morressier/alembic';

export const IconBadge = ({
  icon,
  variant
}: {
  icon: IconProp;
  variant: BadgeVariants;
}) => (
  <Badge size="context" variant={variant}>
    <Flex width={6} height={6} alignItems={'center'} justifyContent={'center'}>
      <FontAwesomeIcon icon={icon} />
    </Flex>
  </Badge>
);
